import { render, staticRenderFns } from "./ButtonRed.vue?vue&type=template&id=761e4750&scoped=true&"
import script from "./ButtonRed.vue?vue&type=script&lang=js&"
export * from "./ButtonRed.vue?vue&type=script&lang=js&"
import style0 from "./ButtonRed.vue?vue&type=style&index=0&id=761e4750&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "761e4750",
  null
  
)

export default component.exports